(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rolling-bannerryanf"] && !Shopify.designMode) return;
  try {
    
  function initRollingBanners() {
    document.querySelectorAll('[data-rolling-banner]').forEach(function (root) {
      if (root.dataset.rollingInitialized) return;
      root.dataset.rollingInitialized = 'true';
      var slides = Array.from(root.querySelectorAll('[data-rolling-slide]'));
      var dots = Array.from(root.querySelectorAll('[data-rolling-dot]'));
      var prevBtn = root.querySelector('[data-rolling-prev]');
      var nextBtn = root.querySelector('[data-rolling-next]');
      if (slides.length < 2) return;

      var interval = parseInt(root.getAttribute('data-interval'), 10) || 3000;
      var current = 0;
      var timer = null;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === current);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }
      function next() { show(current + 1); }
      function prev() { show(current - 1); }
      function start() {
        stop();
        timer = setInterval(next, interval);
      }
      function stop() {
        if (timer) clearInterval(timer);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          start();
        });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      start();
    });
  }

  // The script from {% javascript %} loads as a separate deferred file, so it
  // often finishes AFTER the page's DOMContentLoaded event has already fired.
  // Run immediately if the DOM is already ready; otherwise wait for it.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRollingBanners);
  } else {
    initRollingBanners();
  }

  // Also re-run when a section is added/changed live in the theme editor,
  // since that swaps in new HTML without a full page reload.
  document.addEventListener('shopify:section:load', initRollingBanners);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storiesdiaryryanf1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.story-diaries').forEach(function (root) {
      var cards = Array.from(root.querySelectorAll('[data-story-open]'));
      var modal = document.querySelector('[data-story-modal]');
      if (!cards.length || !modal) return;

      var modalInner = modal.querySelector('.story-diaries__modal-inner');
      var mediaBox = modal.querySelector('[data-story-modal-media]');
      var textBox = modal.querySelector('.story-diaries__modal-text');
      var nameEl = modal.querySelector('[data-story-modal-name]');
      var quoteEl = modal.querySelector('[data-story-modal-quote]');
      var closeBtn = modal.querySelector('[data-story-close]');
      var prevBtn = modal.querySelector('[data-story-prev]');
      var nextBtn = modal.querySelector('[data-story-next]');
      var current = 0;

      var stories = cards.map(function (card, i) {
        var tpl = root.querySelector('template[data-story-embed-index="' + i + '"]');
        return {
          name: card.querySelector('.story-diaries__name') ? card.querySelector('.story-diaries__name').textContent : '',
          quote: card.getAttribute('data-quote') || '',
          embedTemplate: card.getAttribute('data-has-embed') === 'true' ? tpl : null,
          mediaHTML: card.querySelector('.story-diaries__media') ? card.querySelector('.story-diaries__media').outerHTML : ''
        };
      });

      function open(index) {
        current = index;
        var s = stories[current];

        if (s.embedTemplate) {
          // Live Instagram embed mode: clones the pasted embed code (blockquote +
          // Instagram's own script tag) into the popup. Instagram's script does the
          // rest — pulls the real post, caption, likes, straight from Instagram.
          modalInner.classList.add('story-diaries__modal-inner--embed');
          textBox.style.display = 'none';
          mediaBox.innerHTML = '';
          mediaBox.appendChild(s.embedTemplate.content.cloneNode(true));
          modal.hidden = false;
          if (window.instgrm) window.instgrm.Embeds.process();
        } else {
          modalInner.classList.remove('story-diaries__modal-inner--embed');
          textBox.style.display = '';
          mediaBox.innerHTML = s.mediaHTML;
          nameEl.textContent = s.name;
          quoteEl.textContent = s.quote;
          modal.hidden = false;
        }
      }
      function close() {
        modal.hidden = true;
        mediaBox.innerHTML = '';
      }
      function step(dir) {
        var next = (current + dir + stories.length) % stories.length;
        open(next);
      }

      cards.forEach(function (card, i) {
        card.addEventListener('click', function () { open(i); });
      });
      closeBtn.addEventListener('click', close);
      prevBtn.addEventListener('click', function () { step(-1); });
      nextBtn.addEventListener('click', function () { step(1); });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) close();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
